import request from '@/utils/request'

/**
 * 查询单个设备
 */
export const getDeviceInfo = (imei) => {
    return request.post('/device/open/v1/device/getOne', { imei })
}
/**
 * 操作设备
 */
export const optDevice = (imei, params) => {
    return request.post('/device/open/v1/device/opt', { imei, ...params })
}

/**
 * 终端已订购套餐查询
 */
export const queryCardOrder = (terminal, terminalType = "2") => {
    return request.post('/terminal/open/v1/terminalCard/queryCardOrderPackage', { terminal, terminalType })
}

/**
 * 终端可充值套餐查询
 */
export const queryCardPackage = (terminal, terminalType = "2") => {
    return request.post('/terminal/open/v1/terminalCard/queryCardPackage', { terminal, terminalType })
}

/**
 * 从已加载的可充值套餐查询符合id相同的套餐
 */
export const queryPackageById = (packageId) => {
    return request.get('/queryCardPackage', { params: { packageId } })
}

/**
 * 查询设备天用量
 */
export const queryDeviceDayUsed = (startTime, endTime, imei) => {
    return request.post('/terminal/open/v1/terminalDevice/queryDeviceDayUsed', { startTime, endTime, imeiList: [imei] })
}

/**
 * 查询单卡月用量
 */
export const queryCardMonthUsed = (iccid, month) => {
    return request.post('/terminal/open/v1/terminalCard/queryCardMonthUsed', { terminal: iccid, month })
}

/**
 * 单卡实名状态查询
 */
export const queryCarRealNameStatus = (iccid) => {
    return request.post('/terminal/open/v1/terminalCard/queryCardRealIsRealNameStatusDetail', { terminal: iccid })
}

/**
 * 创建订单
 * @param packageId 商品id
 */
export const createOrder = (terminal, packageId) => {
    return request.post('/admin-api/pay/demo-order/create', { deviceId: terminal, spuId: packageId })
}

/**
 * 提交订单
 * @param {支付id} payId 
 * @returns 
 */
export const submitOrder = (payId, openid) => {
    return request.post('/admin-api/pay/order/submit', {
        id: payId,
        channelCode: "wx_pub",
        channelExtras: {
            openid
        },
        returnUrl: "http://cepay.szce.com/admin-api/pay/notify/order"
    })
}

/**
 * 根据wx授权码获取openid
 */
export const authcode2Openid = (code) => {
    return request.get('/wx/access-token', {
        params: {
            code
        }
    })
}

/**
 * 获取订单信息
 * @param {订单id} id 
 * @returns 
 */
export const getOrder = (id) => {
    return request.get('/admin-api/pay/order/get', {
        params: {
            id,
            sync: true,
        }
    })
}

/**
 * 获取已支付订单
 */
export const getPaidOrderList = (terminal, startTime, endTime) => {
    return request.get('/admin-api/pay/demo-order/paid-list', {
        params: {
            deviceId: terminal,
            startTime,
            endTime,
        }
    })
}

/**
 * 根据手机号查找终端号
 */
export const getDeviceNoByMobile = (mobile) => {
    return request.get('/v2/app-api/device/device-imei', {
        params: { mobile }
    })
}

/**
 * 设备登录
 * @param {终端号} account
 */
export const deviceLogin = (deviceNo, cardList) => {
    return request.post('/v2/app-api/device/device-login', { deviceNo, cardList })
}

/**
 * 获取绑定信息
 */
export const getDeviceBindInfo = (deviceNo) => {
    return request.get('/v2/app-api/device/bind-info', {
        params: {
            deviceNo
        }
    })
}

/**
 * 发送绑定手机验证码
 */
export const sendSmsCode = (mobile) => {
    return request.post('/v2/app-api/device/bind-code', {}, { params: { mobile } })
}

/**
 * 发送解绑手机验证码
 */
export const sendUnbindSmsCode = (deviceNo) => {
    return request.post('/v2/app-api/device/unbind-code', {}, { params: { deviceNo } })
}

/**
 * 绑定手机
 */
export const bindMobile = (deviceNo, mobile, smsCode) => {
    return request.post('/v2/app-api/device/bind-mobile', { deviceNo, mobile, smsCode })
}

/**
 * 解绑手机
 */
export const unbindMobile = (deviceNo, smsCode) => {
    return request.post('/v2/app-api/device/unbind-mobile', { deviceNo, smsCode })
}

/**
 * 修改设备名称
 */
export const updateDeviceName = (deviceNo, deviceName) => {
    return request.post('/v2/app-api/device/update-device-name', { deviceNo, deviceName })
}

/**
 * 获取租户信息
 */
export const getTenantByWebsite = (website) => {
    return request.get('/v2/app-api/system/tenant/get-by-website?website=' + website)
}

/**
 * 获取套餐列表
 */
export const getCardPackageList = (terminal, terminalType = "2") => {
    return request.get('/v2/app-api/device/card-package', {
        params: {
            terminal,
            terminalType
        }
    })
}


/**
 * 获取商品结算信息
 */
export const settlement = (packageId, couponId) => {
    return request.get('/v2/app-api/device/settlement', {
        params: {
            spuId: packageId,
            couponId
        }
    })
}

/**
 * 创建订单
 */
export const createTradeOrder = (deviceNo, items, couponId, pointStatus = false, deliveryType = 3) => {
    return request.post('/v2/app-api/trade/order/create', {
        items,
        couponId,
        pointStatus,
        deliveryType,
        receiverName: deviceNo,
        receiverMobile: "",
    })
}

/**
 * 提交订单
 * @param {支付id} payId 
 * @returns 
 */
export const submitOrderV2 = (payId, openid) => {
    return request.post('/v2/app-api/pay/order/submit', {
        id: payId,
        channelCode: "wx_pub",
        channelExtras: {
            openid
        },
        returnUrl: "http://cepay.szce.com/admin-api/pay/notify/order"
    })
}


/**
 * 查询订单列表
 */
export const getOrderList = (startTime, status = [10, 30]) => {
    return request.get('/v2/app-api/trade/order/list', {
        params: {
            status,
            startTime
        }
    })
}

/**
 * 领券中心
 */
export const fetchCoupons = (pageNo = 1, pageSize = 5) => {
    return request.get('/v2/app-api/promotion/coupon-template/page', {
        params: {
            status,
            pageNo,
            pageSize
        }
    })
}
/**
 * 根据状态获取优惠券
 */
export const fetchCouponsByStatus = (status, pageNo = 1, pageSize = 5) => {
    return request.get('/v2/app-api/promotion/coupon/page', {
        params: {
            status,
            pageNo,
            pageSize
        }
    })
}

/**
 *  领取优惠券
 */
export const takeCoupon = (templateId) => {
    return request.post('/v2/app-api/promotion/coupon/take', { templateId })
}